import styled from 'styled-components'

import { MakerTagIcon } from '@root/entities/trade/ui/maker-tag-icon'

import type { Maker } from '@root/entities/trade'

type TradeMakerCellTagsProps = {
  maker: Maker.MakerShort
}

export const TradeMakerCellTags: React.FC<TradeMakerCellTagsProps> = ({
  maker,
}) => {
  const { tags } = maker
  return (
    <Root>
      {tags.map((it) => (
        <MakerTagIcon key={it} tag={it} size={14} />
      ))}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 6px;
`
